import { Mediator, app } from "modular-openscriptjs";
import { eParse, store } from "../helpers";
import { analyze } from "../analytics";
import { api } from "../declarations";

export class AnnouncementMediator extends Mediator {
	$$announcement = {
		was: {
			clicked: (ed, event) => this.clickAnnouncement(ed, event),
		},
	};

	async clickAnnouncement(ed, event) {
		const data = eParse(ed);

		const { announcement, imageIndex, placement } = data.message;

		analyze("announcement_clicked");

		const ua = navigator.userAgent.toLowerCase();
		const device_type = /mobile|android|iphone|ipad/.test(ua)
			? "mobile"
			: "desktop";
		const os = /iphone|ipad|mac/.test(ua)
			? "iOS"
			: /android/.test(ua)
			? "Android"
			: /windows/.test(ua)
			? "Windows"
			: /mac/.test(ua)
			? "macOS"
			: "Other";

		const payload = {
			placement,
			device_type,
			os,
			user_agent: navigator.userAgent,
			clicked_area: `image_${imageIndex}`,
		};

		let res = await api.post(
			`/announcements/${announcement.id}/clicks`,
			payload,
			{
				silent: true,
			}
		);

		if (res) {
			store("current_click", res?.data?.click?.id);
		}
	}
}
